import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import RadioItem from "../components/radio-item-strategy";
import SelectBox from "../components/select-box";
import InitialInvestment from "../components/input-field";
import DashboardHeader from "../components/dashboard-header";
import PortfolioDataGrid from "../components/portfolio-data-grid";
import PortfolioChart from "../components/portfolio-chart";
import VerticalBarChart from "../components/bar-chart";
import { metricColumnDef } from "../data/grid-column-defs";
import DrawdownChart from "../components/draw-down-chart";
import Boxplot from "../components/quantile-chart";
import UnderWaterChart from "../components/under-water-chart";
import TimeSeriesChart from "../components/PortfolioChart";
//import Modal from '@mui/material/Modal';
import { Button, Modal } from "@mui/material";
import HeatmapChart from "../components/heatmap-chart";
//import HeatmapChart from "../components/heatmap-chart-new";

import BookmarkModal from "../components/bookmark-modal";
import BookmarkGrouperModal from "../components/bookmark-grouper-modal";
import StrategyFetchingNotificationModal from "../components/strategy-fetching-notification-modal";

import {
  createChart,
  CrosshairMode,
  LineStyle,
  PriceLineSource,
} from "lightweight-charts";

import {
  defualtErrorMessage,
  graphColorList,
} from "../common/common-variables";
import {
  getTickers,
  searchTickers,
  getMacroSecondaryMetrics,
  getMacroOhlcData,
  getStrategy,
} from "../apis/analysis-apis";
import {
  getBookmarkGroupers,
  toggleBookmark,
  getdashboardInfo,
  toggleFavoriteDashboard,
  getBookmarkStatus,
  favoriteDashboard,
  updateBookmark,
  createBookmarkGrouper,
  getStrategyData,
} from "../apis/user-apis";

import {
  generateChartData,
  generateMatrixData,
} from "../common/common-helper-functions";

import { DatePicker, Radio, Space, notification } from "antd";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import PreLoader from "../components/pre-loader";

const graphDateFormat = "YYYY-MM-DD";
const endDate = "2024-02-15";
const benchmarkDma = 70;
const lookBackPeriod = 90;

// declaration of default values and value lists for dropdowns
//country dropdown
const defaultCountry = { label: "India", value: "India" };
const countryList = [
  {
    label: "India",
    value: "India",
  },
  {
    label: "USA",
    value: "USA",
  },
  {
    label: "Australia",
    value: "Australia",
  },
];

//exchange dropdown
//const defaultExchange = {label: "NSE",  value: "NSE"}

const exchangeList = [
  {
    label: "NSE",
    value: "NSE",
  },
  {
    label: "BSE",
    value: "BSE",
  },
  {
    label: "NASDAQ",
    value: "NASDAQ",
  },
  {
    label: "NYSE ARCA",
    value: "NYSE ARCA",
  },
  {
    label: "AU",
    value: "AU",
  },
];

const allExchangeList = [
  {
    label: "NSE",
    value: "NSE",
  },
  {
    label: "BSE",
    value: "BSE",
  },
  {
    label: "NASDAQ",
    value: "NASDAQ",
  },
  {
    label: "NYSE ARCA",
    value: "NYSE ARCA",
  },
  {
    label: "AU",
    value: "AU",
  },
  { label: "CC", value: "CC" },
  { label: "INDX", value: "INDX" },
];

//indice dropdown
const defaultIndices = { label: "Nifty 50", value: "Nifty 50" };

// list of all the indexes
const indexList = [
  { label: "Nifty 50", value: "Nifty 50" },
  { label: "NIFTY SMALLCAP 250", value: "NIFTY SMALLCAP 250" },
  { label: "NIFTY NEXT 50", value: "NIFTY NEXT 50" },
  { label: "BSE Sensex 30", value: "BSE Sensex 30" },
  { label: "S&P 500 Index", value: "S&P 500 Index" },
  { label: "Nasdaq 100", value: "Nasdaq 100" },
  { label: "S&P/ASX 200", value: "S&P/ASX 200" },
  { label: "S&P/ASX 50", value: "S&P/ASX 50" },
  { label: "S&P/ASX 100", value: "S&P/ASX 100" },
  { label: "Bitcoin", value: "Bitcoin" },
];

//strategy dropdown
const defaultStrategy = {
  label: "Assets On The Move Strategy",
  value: "Assets_On_The_Move_Strategy",
};
const strategyList = [
  {
    label: "Assets On The Move Strategy",
    value: "Assets_On_The_Move_Strategy",
  },
  { label: "Percent Move Strategy", value: "Percent_Move_Strategy" },
];

//frequency dropdown
const defaultFrequency = { label: "Daily", value: "D" };

const frequencyList = [
  { label: "Daily", value: "D" },
  { label: "Weekly", value: "W" },
  { label: "Monthly", value: "M" },
];

// assetlist dropdown
const assetList = [
  { label: "Stock", value: "Stock" },
  { label: "Indices", value: "Indices" },
  { label: "Crypto", value: "Unknown" },
];

const today = new Date();
const DefaultEndDate = today.toISOString().split("T")[0]; // Format today's date as YYYY-MM-DD

// Get the date for two years ago
const twoYearsAgo = new Date(new Date().setFullYear(today.getFullYear() - 2));
const DefaultStartDate = twoYearsAgo.toISOString().split("T")[0]; // Format the date as YYYY-MM-DD

//declaration of the main component
export default function Strategies() {
  // state variables for input components
  const [dashboardTitle, setDashboardTitle] = useState("Strategy Dashboard");
  const [selectCountry, setSelectedCounrty] = useState(defaultCountry);
  const [countryDisabled, setCountryDisabled] = useState(false);
  const [selectExchange, setSelectedExchange] = useState([
    { label: "NSE", value: "NSE" },
  ]);
  const [defaultExchange, setDefaultExchange] = useState({
    label: "NSE",
    value: "NSE",
  });
  const [defaultFrequency, setDefaultFrequency] = useState({
    label: "Daily",
    value: "D",
  });
  const [defaultAsset, setDefaultAsset] = useState({
    label: "Stock",
    value: "Stock",
  });
  const [selectAsset, setSelectAsset] = useState({
    label: "Stock",
    value: "Stock",
  });
  const [defaultIndice, setDefaultIndice] = useState(defaultIndices);
  const [selectIndice, setSelectedIndice] = useState(defaultIndices);
  // const [selectFrequency, setSelectFrequency] = useState(defaultFrequency);
  const [selectStrategyType, setSelectStrategyType] = useState(defaultStrategy);
  const [selectFromIndexConst, setSelectFromIndexConst] = useState(1);
  const [selectInitInvestment, setSelectInitInvestment] = useState(1);
  //const [showModal, setShowModal] = useState(false);

  // states for managing grid data
  const [benchmarkRowData, setBenchmarkRowData] = useState([]);
  const [benchColumnDefs, setBenchColumnDefs] = useState([]);
  const [summaryRowData, setSummaryRowData] = useState([]);
  const [inexRowData, setInexRowData] = useState([]);
  const [inexColumnDefs, setInexColumnDefs] = useState([]);
  const [metricRowData, setMetricRowData] = useState([]);
  const [summaryColumnDefs, setSummaryColumnDefs] = useState([]);
  const [performanceRowData, setPerformanceRowData] = useState([]);
  const [performanceColumnDefs, setPerformanceColumnDefs] = useState([]);
  const [eoyReturnBarData, setEoyReturnBarData] = useState([]);
  const [underwaterData, setUnderwaterData] = useState([]);
  const [cumulativeReturnPortfolioData, setCumulativeReturnPortfolioData] =
    useState([]);
  const [cumulativeReturnBenchmarkData, setCumulativeReturnBenchmarkData] =
    useState([]);
  const [monthlyReturnData, setMonthlyReturnData] = useState([]);
  const excludedColumns = [
    "id",
    "run_id",
    "strategy_params",
    "strat_name",
    "run_date",
    "created_at",
    "updated_at",
  ];

  // states for portfolio charts
  const [portfolioData, setPortfolioData] = useState([]);
  const [benchmarkData, setBenchmarkData] = useState([]);
  const barChartTitle = "EOY Returns";

  const [showGraph, setShowGraph] = useState(false);

  const [graphDate, setGraphDate] = useState({
    startDate: DefaultStartDate,
    endDate: DefaultEndDate,
  });

  const [showLoader, setShowLoader] = useState(true);

  const [primaryData, setPrimaryData] = useState([]);
  const [secondaryData, setSecondaryData] = useState([]);
  const [hoverdValuesLegends, setHoverdValuesLegends] = useState([]);
  const [dataGridValue, setDataGridValue] = useState([]);

  // defining the bookmark related states.
  const [bookmarkName, setBookmarkName] = useState("");
  const [bookmarkNameError, setBookmarkNameError] = useState("");
  const [bookmarkDescription, setBookmarkDescription] = useState("");
  const [bookmarkDescriptionError, setBookmarkDescriptionError] = useState("");
  const [selectedBookmarkFolder, setSelectedBookmarkFolder] = useState("0");
  const [bookmarkFolderError, setBookmarkFolderError] = useState("");
  const [isBookmarkPublic, setIsBookmarkPublic] = useState(false);
  const [isDashboardBookmarked, setIsDashboardBookmarked] = useState(false);
  const [isBookmarkModalOpen, setIsBookmarkModalOpen] = useState(false);
  const [bookmarkFolders, setBookmarkFolders] = useState([]);
  const [isBookmarkGrouperModalOpen, setIsBookmarkGrouperModalOpen] =
    useState(false);
  const [bookmarkGrouperInput, setBookmarkGrouperInput] = useState("");
  const [bookmarkGrouperInputError, setBookmarkGrouperInputError] =
    useState("");

  //  Like related states
  const [isDashboardLiked, setIsDashboardLiked] = useState(false);

  // contains all the information about the dashboard
  const [dashboardInfo, setDashboardInfo] = useState({});

  // contains all the information about the bookmark
  const [bookmarkInfo, setBookmarkInfo] = useState({});

  // contains all the information about the bookmark form
  const [bookmarkFormInfo, setBookmarkFormInfo] = useState({});

  // should show the notification modal.
  const [showNotificationModal, setShowNotificationModal] = useState(false);

  const chartContainerRef = useRef();
  const chart = useRef();
  const tooltipRef = useRef();

  // data manipulation for drawdown, not being used right now. code has been kept for future use.

  //   const drawdownData = {
  //     "start": {"0": "2023-05-15", "1": "2023-05-30", "2": "2023-06-02", "3": "2023-06-07"},
  //     "valley": {"0": "2023-05-25", "1": "2023-05-30", "2": "2023-06-02", "3": "2023-09-13"},
  //     "end": {"0": "2023-05-26", "1": "2023-05-30", "2": "2023-06-05", "3": "2024-02-15"},
  //     "days": {"0": 12, "1": 1, "2": 4, "3": 254},
  //     "max drawdown": {"0": -1.980198019801982, "1": -0.990099009900991, "2": -0.990099009900991, "3": -26.732673267326735},
  //     "99% max drawdown": {"0": -0.990099009900991, "1": NaN, "2": NaN, "3": -25.742574257425744}
  // };

  // Convert drawdown data into suitable format for the DrawdownChart component
  // const chartData = Object.keys(drawdownData).map((key) => {
  //     // Handle NaN values
  //     const drawdownValue = isNaN(drawdownData[key][0]) ? 0 : drawdownData[key][0];
  //     return { x: key, y: drawdownValue };
  // });

  // to open bookmark folder
  const handleOpenBookmarkModal = () => {
    setIsBookmarkModalOpen(true);
  };

  // to close bookmark folder
  const handleCloseBookmarkModal = () => {
    setIsBookmarkModalOpen(false);
  };

  const handleChangeDate = (selectedDate) => {
    const startDate = selectedDate[0].format("YYYY-MM-DD");
    const endDate = selectedDate[1].format("YYYY-MM-DD");

    setGraphDate({
      startDate: startDate,
      endDate: endDate,
    });
  };

  const [open, setOpen] = useState(false);

  const [isStrategyLoading, setIsStrategyLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // function for country dropdown
  const handleChangeCountry = (selectedCountry) => {
    setSelectedCounrty(selectedCountry);
    adjustExchangeIndices(selectAsset.value, selectedCountry.value);
  };

  // function for exchange dropdown
  const handleChangeExchange = (selectedExchange) => {
    setDefaultExchange(selectedExchange);
  };

  // function for indice dropdown
  const handleChangeIndice = (selectedIndice) => {
    ////console.log("Length of ",selectedIndice)
    setDefaultIndice(selectedIndice);
  };

  const handleChangeFrequency = (selectedFrequency) => {
    // console.log(selectedFrequency);
    setDefaultFrequency(selectedFrequency);
    handleGraphDate(selectedFrequency["value"]);
  };

  const handleChangeStrategy = (selectedStrategy) => {
    setSelectStrategyType(selectedStrategy);
  };

  //function for assetType change

  const handleChangeAsset = (selectedAsset) => {
    setSelectAsset(selectedAsset);
    adjustExchangeIndices(selectedAsset.value, selectCountry.value);
  };

  const radioOnChange = (fromIndexCons) => {
    ////console.log(assetType)
    setSelectFromIndexConst(fromIndexCons);
  };

  // for changing the initial investment

  const investmentOnChange = (selectedInitInvestment) => {
    setSelectInitInvestment(selectedInitInvestment);
  };

  // to check if the dashboard is favorite of not.
  useEffect(() => {
    //console.log("checking if dashboard is favorite or not");
    const source = axios.CancelToken.source();
    //console.log(dashboardInfo.id);

    if (dashboardInfo.id) {
      const params = {
        dashboard_id: dashboardInfo.id,
        cancelToken: source.token,
      };
      favoriteDashboard(params)
        .then((resp) => {
          // updating the dashoard like status
          //console.log(resp.data.is_dashboard_liked);
          setIsDashboardLiked(resp.data.is_dashboard_liked);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            ////console.log("request cancel successfully.")
          } else {
            ////console.log("need to handel this error.", err)
          }
        });
    }

    return () => {
      ////console.log('canceling the request')
      source.cancel("Request canceled by cleanup");
    };
  }, [dashboardInfo.id]);

  // fetching the bookmark folders.
  useEffect(() => {
    getBookmarkGroupers()
      .then((resp) => {
        setBookmarkFolders(resp?.data ? resp.data : []);
      })
      .catch((err) => {
        //console.log("this is the error while fetching bookmarks folders", err);
      });
  }, []);

  // to update the bookmark status as per change in inputs.
  useEffect(() => {
    const source = axios.CancelToken.source();
    if (dashboardInfo.id) {
      const bookmarkParameters = getBookmarkParameters();
      const payload = {
        dashboard_id: dashboardInfo.id,
        bookmark_parameters: bookmarkParameters,
        cancelToken: source.token,
      };

      getBookmarkStatus(payload)
        .then((resp) => {
          // updating the dashboard title
          setDashboardTitle(resp.data.name);
          // updating the dashboard title
          setIsBookmarkPublic(resp.data.is_public ? true : false);
          // updating the dashboard title
          setIsDashboardBookmarked(resp.data.is_bookmarked ? true : false);

          // also updating the bookmark form

          setBookmarkName(resp.data.is_bookmarked ? resp.data.name : "");
          setBookmarkDescription(
            resp.data.is_bookmarked ? resp.data.description : ""
          );
          setSelectedBookmarkFolder(
            resp.data.is_bookmarked ? resp.data.grouper : "0"
          );
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            ////console.log("request cancel successfully.")
          } else {
            ////console.log("need to handel this error.", err)
          }
        });
    }

    return () => {
      ////console.log('canceling the request')
      source.cancel("Request canceled by cleanup");
    };
  }, [
    dashboardInfo.id,
    defaultExchange,
    defaultIndice,
    defaultFrequency,
    selectStrategyType,
    selectFromIndexConst,
    selectInitInvestment,
    selectCountry,
    selectAsset,
  ]);

  // fetching the dashboard info
  useEffect(() => {
    const source = axios.CancelToken.source();
    //console.log("getting dashboard info");
    const paramsObject = {
      dashboard_path: location.pathname,
      cancelToken: source.token,
    };
    //console.log(paramsObject);
    getdashboardInfo(paramsObject)
      .then((resp) => {
        //console.log(resp.data);
        setDashboardInfo(resp.data);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          ////console.log("request cancel successfully.")
        } else {
          ////console.log("need to handel this error.", err)
        }
      });
    return () => {
      ////console.log('canceling the request')
      source.cancel("Request canceled by cleanup");
    };
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.size && searchParams.has("request_id")) {
      // setting the input fields according to the queryset parameters.
      const requestId = searchParams.get("request_id");

      setIsStrategyLoading(true);

      getStrategyData({ request_id: requestId })
        .then((resp) => {
          let responseData = resp.data;
          // TODO
          if (typeof responseData === "string") {
            responseData = JSON.parse(responseData);
          }
          let parameters = responseData?.parameters;
          //console.log("this are the params", parameters);
          if (typeof parameters === "string") {
            parameters = eval("(" + parameters + ")");
          }
          //console.log("this are the typeOf params", typeof parameters);
          //console.log(
          //   "this are the responseData?.response_data",
          //   responseData?.response_data
          // );

          //console.log("parameters.indexes?.[0]", parameters.indexes?.[0]);
          setStrategyData(responseData?.response_data);

          // countryList
          // allExchangeList
          // indexList
          // strategyList

          const fromIndexConstituent = parseInt(
            parameters?.from_index_const,
            10
          );
          const initialInvestment = parseInt(
            parameters?.initial_investment,
            10
          );
          const startDate = parameters?.start_dt;
          const endDate = parameters?.end_dt;

          const selectedCountryOption = countryList.find(
            (item) => item.value === parameters.countries?.[0]
          );
          const selectedExchangeOption = allExchangeList.find(
            (item) => item.value === parameters.exchanges?.[0]
          );
          const selectedFrequencyOption = frequencyList.find(
            (item) => item.value === parameters.frequency?.[0]
          );
          const selectedIndexOption = indexList.find(
            (item) => item.value === parameters.indexes?.[0]
          );
          const selectedStrategyOption = strategyList.find(
            (item) => item.value === parameters.strategy_type
          );
          const selectAssetOption = assetList.find(
            (item) => item.value === parameters.asset_type
          );

          setSelectAsset(selectAssetOption);
          setSelectedCounrty(selectedCountryOption);
          setDefaultExchange(selectedExchangeOption);
          setDefaultIndice(selectedIndexOption);
          setDefaultFrequency(selectedFrequencyOption);
          setSelectStrategyType(selectedStrategyOption);
          setSelectFromIndexConst(fromIndexConstituent);
          setSelectInitInvestment(initialInvestment);
          setGraphDate({
            startDate: startDate,
            endDate: endDate,
          });
          //console.log("fromIndexConstituent", fromIndexConstituent);
          //console.log("selectedCountryOption", selectedCountryOption);
          //console.log("selectedExchangeOption", selectedExchangeOption);
          //console.log("selectedFrequencyOption", selectedFrequencyOption);
          console.log("selectedIndexOption", selectedIndexOption);
          //console.log("selectedStrategyOption", selectedStrategyOption);
          //console.log("selectAssetOption", selectAssetOption);

          // validate the respose.
          // set the input fields as per paramerters.
          // set the data as per response response_data.
          setIsStrategyLoading(false);
        })
        .catch((err) => {
          console.log("this is the error", err);
        });
    }
  }, []);

  // fetching the bookmarks from parameters
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.size && !searchParams.has("request_id")) {
      // setting the input fields according to the queryset parameters.

      const selectAsset = searchParams.has("asset_type")
        ? JSON.parse(searchParams.get("asset_type"))
        : selectAsset;
      const selectCountry = searchParams.has("countries")
        ? JSON.parse(searchParams.get("countries"))
        : selectCountry;
      const selectIndex = searchParams.has("indexes")
        ? JSON.parse(searchParams.get("indexes"))
        : selectIndex;
      const selectExchange = searchParams.has("exchanges")
        ? searchParams.get("exchanges")
        : selectExchange;
      const selectFrequency = searchParams.has("frequencies")
        ? searchParams.get("frequencies")
        : selectFrequency;
      const initialinvestment = searchParams.has("initialinvestment")
        ? JSON.parse(searchParams.get("initialinvestment"))
        : initialinvestment;
      const fromIndxConst = searchParams.has("from_index_constituents")
        ? JSON.parse(searchParams.get("from_index_constituents"))
        : fromIndxConst;
      const strat_name = searchParams.has("strat_name")
        ? JSON.parse(searchParams.get("strat_name"))
        : strat_name;

      //console.log("this is the selectPrimaryMetrics", selectAsset);
      //console.log("this is the selectCountry", selectCountry);
      //console.log("this is the selectFrequency", selectFrequency);
      //console.log("this is the selectExchange", selectExchange);
      //console.log("this is the selectIndex", selectIndex);
      // //console.log("this is the endDate", endDate)
      // //console.log("this is the strat_name", strat_name)
      //console.log("this is the initialinvestment", initialinvestment);
      //console.log("this is the fromIndxConst", fromIndxConst);
      setSelectAsset(selectAsset);
      setSelectedCounrty(selectCountry);
      setDefaultExchange(selectExchange);
      setDefaultIndice(selectIndex);
      setDefaultFrequency(selectFrequency);
      setSelectStrategyType(strat_name);
      setSelectFromIndexConst(fromIndxConst);
      setSelectInitInvestment(initialinvestment);
    }

    const paramsObject = {
      dashboard_name: "producer_price_index_react_codes",
      dashboard_path: location.pathname,
    };

    getMacroSecondaryMetrics(paramsObject)
      .then((resp) => {
        const secondaryOptions = resp.data.data;
        setSecondaryMetricOptions(secondaryOptions);
        setDashboardTitle(resp.data.dashboard_title);
      })
      .catch((err) => {
        //////console.log("this is the error", err)
      });
  }, []);

  // // use effect to fetch data from API and extract data for different charts
  // useEffect(
  //   () => {
  //     const searchParams = new URLSearchParams(location.search);
  //     if (!searchParams.has("request_id")) {
  //       setIsStrategyLoading(true);
  //       //console.log("inside the data fetch");
  //       ////console.log("frequency is ",defaultFrequency)
  //       //console.log("date is ", graphDate);
  //       //console.log("start Date", graphDate["startDate"]);
  //       //console.log("indices are", defaultIndice);
  //       let fromIndexConstituent = true;
  //       if (!selectFromIndexConst) {
  //         fromIndexConstituent = false;
  //       }
  //       let countries = "";
  //       if (selectAsset["value"] === "Unknown") {
  //         countries = "Unknown";
  //       } else {
  //         countries = selectCountry["value"];
  //       }
  //       //const startDate = defaultFrequency['value'] === 'W' ? "2020-01-01" : defaultFrequency['value'] === 'M' ? "2013-01-01" : "2023-01-01";

  //       const parameters = getParameters();
  //       var indices = encodeURIComponent(defaultIndice["value"]);

  //       const params = {
  //         id_tag: "strategy__backtest",
  //         invoke_type: "aws",
  //         logic_function: "run_adhoc_strategy",
  //         asset_type: selectAsset["value"],
  //         end_dt: graphDate["endDate"],
  //         start_dt: graphDate["startDate"],
  //         countries: countries,
  //         exchanges: defaultExchange["value"],
  //         frequency: defaultFrequency["value"],
  //         indexes: indices,
  //         initial_investment: selectInitInvestment,
  //         benchmark_dma: benchmarkDma,
  //         risk_free_rate: 0.04,
  //         lookback_period: lookBackPeriod,
  //         no_of_positions: 3,
  //         rebalance_frequency: 23,
  //         use_benchmark_exit_signal: true,
  //         from_index_constituents: fromIndexConstituent,
  //         strat_name: selectStrategyType["value"],
  //         notification_name: selectStrategyType["label"],
  //         from_index_const: selectFromIndexConst,
  //         // "parameters" : parameters
  //       };
  //       getStrategy(params)
  //         .then((resp) => {
  //           //console.log("inside the data fetch");
  //           //console.log("resp.data", resp.data);

  //           if (resp.data.body.request_id === "dummy") {
  //             //console.log("insideif");
  //             const stratBenchmark = JSON.parse(
  //               resp.data.body.result.strat_benchmark
  //             );
  //             const stratSummary = JSON.parse(
  //               resp.data.body.result.strat_summary
  //             );
  //             const stratInclusionExclusion = JSON.parse(
  //               resp.data.body.result.strat_inclusion_exclusion
  //             );

  //             const stratPerformance = JSON.parse(
  //               resp.data.body.result.strat_performance
  //             );
  //             //console.log("printing");
  //             //console.log(
  //             //   stratPerformance[0]["performance_data"]["drawdown_details"]
  //             // );
  //             const portfiloReturnData =
  //               stratPerformance[0]["performance_data"]["portfolio_returns"];
  //             const benchmarkReturnData =
  //               stratPerformance[0]["performance_data"]["benchmark_returns"];

  //             const monthlYReturnData =
  //               stratPerformance[0]["performance_data"]["monthly_returns"];
  //             const monthlyReturnJson = JSON.parse(monthlYReturnData);
  //             setMonthlyReturnData(monthlyReturnJson);
  //             const metrics =
  //               stratPerformance[0]["performance_data"]["metrics"];
  //             const metricJson = JSON.parse(metrics);
  //             // data to prepare for comparison between benchmark and portfolio

  //             const gridData = [];

  //             for (const metric of Object.keys(metricJson["Benchmark"])) {
  //               const benchmarkValue = metricJson["Benchmark"][metric];
  //               const strategyValue = metricJson["Strategy"][metric];
  //               gridData.push({
  //                 Metric: metric,
  //                 Benchmark: benchmarkValue,
  //                 Strategy: strategyValue,
  //               });
  //             }

  //             setMetricRowData(gridData);

  //             // setting data for plotting return data
  //             setPortfolioData(portfiloReturnData);
  //             setBenchmarkData(benchmarkReturnData);

  //             // setting data for EOY bar chart
  //             const eoyReturnBenchmark =
  //               stratPerformance[0]["performance_data"][
  //                 "eoy_returns_benchmark"
  //               ];
  //             const eoyReturnPortfolio =
  //               stratPerformance[0]["performance_data"][
  //                 "eoy_returns_portfolio"
  //               ];

  //             const eoyReturnData = generateChartData(
  //               eoyReturnBenchmark,
  //               eoyReturnPortfolio
  //             );
  //             // console.log("printing data for bar")
  //             // console.log(eoyReturnData)
  //             setEoyReturnBarData(eoyReturnData);
  //             // drawdown chart
  //             // const drawDownDetails =  stratPerformance[0]['performance_data']['drawdown_details']
  //             // console.log("printing drawdown data")
  //             // console.log(drawDownDetails)
  //             const underwaterData =
  //               stratPerformance[0]["performance_data"]["underwater_data"];
  //             // console.log("printing underwater data")
  //             // console.log(underwaterData)
  //             setUnderwaterData(underwaterData);
  //             // getting data for monthly return

  //             const cumulativeReturnPort =
  //               stratPerformance[0]["performance_data"][
  //                 "cumulative_returns_portfolio"
  //               ];
  //             const cumulativeReturnBench =
  //               stratPerformance[0]["performance_data"][
  //                 "cumulative_returns_benchmark"
  //               ];

  //             setCumulativeReturnBenchmarkData(cumulativeReturnPort);
  //             setCumulativeReturnPortfolioData(cumulativeReturnBench);

  //             setBenchmarkRowData(stratBenchmark); // Store stratbenchmark data in rowData state variable
  //             setSummaryRowData(stratSummary); // Store stratbenchmark data in rowData state variable
  //             setInexRowData(stratInclusionExclusion);
  //             setPerformanceRowData(stratPerformance); // Store stratbenchmark data in rowData state variable
  //             if (stratBenchmark.length > 0) {
  //               const firstObjectKeys = Object.keys(stratBenchmark[0]);
  //               const newColumnDefs = firstObjectKeys
  //                 .filter((key) => !excludedColumns.includes(key))
  //                 .map((key) => ({
  //                   headerName: key
  //                     .replace(/_/g, " ")
  //                     .replace(/\b\w/g, (char) => char.toUpperCase()),
  //                   field: key,
  //                 }));
  //               const filteredColumnDefs = newColumnDefs.filter(
  //                 (column) => !excludedColumns.includes(column.field)
  //               );
  //               setBenchColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
  //             }

  //             if (stratSummary.length > 0) {
  //               const firstObjectKeys = Object.keys(stratSummary[0]);
  //               const newColumnDefs = firstObjectKeys.map((key) => ({
  //                 headerName: key
  //                   .replace(/_/g, " ")
  //                   .replace(/\b\w/g, (char) => char.toUpperCase()),
  //                 field: key,
  //               }));
  //               const filteredColumnDefs = newColumnDefs.filter(
  //                 (column) => !excludedColumns.includes(column.field)
  //               );
  //               setSummaryColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
  //             }
  //             if (stratPerformance.length > 0) {
  //               const firstObjectKeys = Object.keys(stratPerformance[0]);
  //               const newColumnDefs = firstObjectKeys.map((key) => ({
  //                 headerName: key
  //                   .replace(/_/g, " ")
  //                   .replace(/\b\w/g, (char) => char.toUpperCase()),
  //                 field: key,
  //               }));
  //               const filteredColumnDefs = newColumnDefs.filter(
  //                 (column) => !excludedColumns.includes(column.field)
  //               );
  //               setPerformanceColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
  //             }

  //             if (stratInclusionExclusion.length > 0) {
  //               const firstObjectKeys = Object.keys(stratInclusionExclusion[0]);
  //               const newColumnDefs = firstObjectKeys.map((key) => ({
  //                 headerName: key
  //                   .replace(/_/g, " ")
  //                   .replace(/\b\w/g, (char) => char.toUpperCase()),
  //                 field: key,
  //               }));
  //               const filteredColumnDefs = newColumnDefs.filter(
  //                 (column) => !excludedColumns.includes(column.field)
  //               );
  //               setInexColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
  //             }
  //           } else {
  //             // show user pop up
  //             // const respData = JSON.parse(resp.data.body);
  //             const respData = resp.data.body;
  //             //console.log("respDataa", respData);
  //             setShowNotificationModal(true);
  //             window.fetchNotificationStatus(respData.request_id);
  //             try {
  //               let serializedState = sessionStorage.getItem(
  //                 "notification-request-ids"
  //               );
  //               if (serializedState) {
  //                 const parsedserializedState = JSON.parse(serializedState);
  //                 parsedserializedState.push(respData.request_id);
  //                 serializedState = JSON.stringify(parsedserializedState);
  //                 sessionStorage.setItem(
  //                   "notification-request-ids",
  //                   serializedState
  //                 );
  //               } else {
  //                 serializedState = JSON.stringify([respData.request_id]);
  //                 sessionStorage.setItem(
  //                   "notification-request-ids",
  //                   serializedState
  //                 );
  //               }
  //             } catch (error) {
  //               console.error("Could not load state", error);
  //             }
  //             //console.log("inside else");
  //           }
  //           setIsStrategyLoading(false);
  //         })
  //         .catch((err) => {
  //           //console.log("this is the error", err);
  //         });
  //     }
  //   },
  //   // [defaultExchange,
  //   // defaultIndice,
  //   // //defaultFrequency,
  //   // selectStrategyType,
  //   // selectFromIndexConst,
  //   // selectInitInvestment,
  //   // graphDate]
  //   []
  // );

  // useEffct to update exchange. indices based on chosen country/asset type

  const setStrategyData = (data) => {
    const stratBenchmark = JSON.parse(data.strat_benchmark);
    const stratSummary = JSON.parse(data.strat_summary);
    const stratInclusionExclusion = JSON.parse(data.strat_inclusion_exclusion);
    const stratPerformance = JSON.parse(data.strat_performance);

    //console.log(
    //   "stratPerformance type*******",
    //   typeof stratPerformance[0]["performance_data"]
    // );

    let performanceData = stratPerformance[0]["performance_data"];

    if (typeof performanceData === "string") {
      //console.log("parsing agian*******");
      performanceData = JSON.parse(performanceData);
    }

    const portfiloReturnData = performanceData["portfolio_returns"];
    const benchmarkReturnData = performanceData["benchmark_returns"];
    const monthlYReturnData = performanceData["monthly_returns"];
    const monthlyReturnJson = JSON.parse(monthlYReturnData);

    setMonthlyReturnData(monthlyReturnJson);

    const metrics = performanceData["metrics"];
    const metricJson = JSON.parse(metrics);

    // data to prepare for comparison between benchmark and portfolio
    const gridData = [];

    for (const metric of Object.keys(metricJson["Benchmark"])) {
      const benchmarkValue = metricJson["Benchmark"][metric];
      const strategyValue = metricJson["Strategy"][metric];
      gridData.push({
        Metric: metric,
        Benchmark: benchmarkValue,
        Strategy: strategyValue,
      });
    }

    setMetricRowData(gridData);

    // setting data for plotting return data
    setPortfolioData(portfiloReturnData);
    setBenchmarkData(benchmarkReturnData);

    // setting data for EOY bar chart
    const eoyReturnBenchmark = performanceData["eoy_returns_benchmark"];
    const eoyReturnPortfolio = performanceData["eoy_returns_portfolio"];

    const eoyReturnData = generateChartData(
      eoyReturnBenchmark,
      eoyReturnPortfolio
    );
    // //console.log("printing data for bar")
    // //console.log(eoyReturnData)
    setEoyReturnBarData(eoyReturnData);
    // drawdown chart
    // const drawDownDetails =  stratPerformance[0]['performance_data']['drawdown_details']
    // //console.log("printing drawdown data")
    // //console.log(drawDownDetails)
    const underwaterData = performanceData["underwater_data"];
    // //console.log("printing underwater data")
    // //console.log(underwaterData)
    setUnderwaterData(underwaterData);
    // getting data for monthly return

    const cumulativeReturnPort =
      performanceData["cumulative_returns_portfolio"];
    const cumulativeReturnBench =
      performanceData["cumulative_returns_benchmark"];

    setCumulativeReturnBenchmarkData(cumulativeReturnPort);
    setCumulativeReturnPortfolioData(cumulativeReturnBench);

    setBenchmarkRowData(stratBenchmark); // Store stratbenchmark data in rowData state variable
    setSummaryRowData(stratSummary); // Store stratbenchmark data in rowData state variable
    setInexRowData(stratInclusionExclusion);
    setPerformanceRowData(stratPerformance); // Store stratbenchmark data in rowData state variable
    if (stratBenchmark.length > 0) {
      const firstObjectKeys = Object.keys(stratBenchmark[0]);
      const newColumnDefs = firstObjectKeys
        .filter((key) => !excludedColumns.includes(key))
        .map((key) => ({
          headerName: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          field: key,
        }));
      const filteredColumnDefs = newColumnDefs.filter(
        (column) => !excludedColumns.includes(column.field)
      );
      setBenchColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
    }

    if (stratSummary.length > 0) {
      const firstObjectKeys = Object.keys(stratSummary[0]);
      const newColumnDefs = firstObjectKeys.map((key) => ({
        headerName: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        field: key,
      }));
      const filteredColumnDefs = newColumnDefs.filter(
        (column) => !excludedColumns.includes(column.field)
      );
      setSummaryColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
    }
    if (stratPerformance.length > 0) {
      const firstObjectKeys = Object.keys(stratPerformance[0]);
      const newColumnDefs = firstObjectKeys.map((key) => ({
        headerName: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        field: key,
      }));
      const filteredColumnDefs = newColumnDefs.filter(
        (column) => !excludedColumns.includes(column.field)
      );
      setPerformanceColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
    }

    if (stratInclusionExclusion.length > 0) {
      const firstObjectKeys = Object.keys(stratInclusionExclusion[0]);
      const newColumnDefs = firstObjectKeys.map((key) => ({
        headerName: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        field: key,
      }));
      const filteredColumnDefs = newColumnDefs.filter(
        (column) => !excludedColumns.includes(column.field)
      );
      setInexColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
    }
  };

  const adjustExchangeIndices = (selectedAssetType, selectedCountryOption) => {
    //console.log("changing the Asset types");
    //console.log(selectAsset);
    //console.log(selectCountry);
    if (selectedAssetType == "Indices") {
      setCountryDisabled(false);
      const ExchangeOptions = [{ label: "INDX", value: "INDX" }];
      setSelectedExchange(ExchangeOptions);
      setDefaultExchange({ label: "INDX", value: "INDX" });

      if (selectedCountryOption == "USA") {
        const IndicesOption = [
          { label: "S&P 500 Index", value: "S&P 500 Index" },
          { label: "Nasdaq 100", value: "Nasdaq 100" },
        ];
        setSelectedIndice(IndicesOption);
        setDefaultIndice({ label: "Nasdaq 100", value: "Nasdaq 100" });
      }

      if (selectedCountryOption == "India") {
        const IndicesOption = [
          { label: "BSE Sensex 30", value: "BSE Sensex 30" },
          { label: "Nifty 50", value: "Nifty 50" },
        ];
        setSelectedIndice(IndicesOption);
        setDefaultIndice({ label: "Nifty 50", value: "Nifty 50" });
      }
      if (selectedCountryOption == "Australia") {
        const IndicesOption = [
          { label: "S&P/ASX 200", value: "S&P/ASX 200" },
          { label: "S&P/ASX 50", value: "S&P/ASX 50" },
        ];
        setSelectedIndice(IndicesOption);
        setDefaultIndice({ label: "S&P/ASX 200", value: "S&P/ASX 200" });
      }
    }

    // for asset type Stocks
    if (selectedAssetType == "Stock") {
      //console.log("in here");
      setCountryDisabled(false);
      if (selectedCountryOption == "USA") {
        const ExchangeOptions = [
          { label: "NASDAQ", value: "NASDAQ" },
          { label: "NYSE ARCA", value: "NYSE ARCA" },
        ];
        const IndicesOption = [
          { label: "S&P 500 Index", value: "S&P 500 Index" },
          { label: "Nasdaq 100", value: "Nasdaq 100" },
        ];
        setSelectedExchange(ExchangeOptions);
        setDefaultExchange({ label: "NASDAQ", value: "NASDAQ" });
        setSelectedIndice(IndicesOption);
        setDefaultIndice({ label: "Nasdaq 100", value: "Nasdaq 100" });
      }
      if (selectedCountryOption == "India") {
        const ExchangeOptions = [{ label: "NSE", value: "NSE" }];
        const IndicesOption = [
          { label: "NIFTY SMALLCAP 250", value: "NIFTY SMALLCAP 250" },
          { label: "Nifty 50", value: "Nifty 50" },
          { label: "NIFTY NEXT 50", value: "NIFTY NEXT 50" },
        ];
        setSelectedExchange(ExchangeOptions);
        setDefaultExchange({ label: "NSE", value: "NSE" });
        setSelectedIndice(IndicesOption);
        setDefaultIndice({ label: "Nifty 50", value: "Nifty 50" });
      }
      if (selectedCountryOption == "Australia") {
        const ExchangeOptions = [{ label: "AU", value: "AU" }];
        const IndicesOption = [
          { label: "S&P/ASX 200", value: "S&P/ASX 200" },
          { label: "S&P/ASX 50", value: "S&P/ASX 50" },
          { label: "S&P/ASX 100", value: "S&P/ASX 100" },
        ];
        setSelectedExchange(ExchangeOptions);
        setDefaultExchange({ label: "AU", value: "AU" });
        setSelectedIndice(IndicesOption);
        setDefaultIndice({ label: "S&P/ASX 50", value: "S&P/ASX 50" });
      }
    }
    //for crypto
    if (selectedAssetType == "Unknown") {
      const ExchangeOptions = [{ label: "CC", value: "CC" }];

      const IndicesOption = [{ label: "Bitcoin", value: "Bitcoin" }];

      setSelectedExchange(ExchangeOptions);
      setDefaultExchange({ label: "CC", value: "CC" });
      setSelectedIndice(IndicesOption);
      setDefaultIndice({ label: "Bitcoin", value: "Bitcoin" });
      setCountryDisabled(true);
    }
  };

  const handleGraphDate = (freq) => {
    let startDate = null;
    let endDate = null;
    const bigger = Math.max(lookBackPeriod, benchmarkDma);
    if (freq === "D") {
      startDate = "2023-01-01";
      endDate = "2024-02-15";
    }
    if (freq === "W") {
      endDate = "2024-02-15";
      startDate = "2021-01-01";
      var newEndDate = new Date(endDate); // Convert endDate to a Date object

      // Calculate the number of milliseconds in 100 weeks
      var weeksInMilliseconds = (bigger + 50) * 7 * 24 * 60 * 60 * 1000;

      // Calculate the date 100 weeks before the given date
      var date100WeeksBefore = new Date(
        newEndDate.getTime() - weeksInMilliseconds
      );
      // Format the date as yyyy-mm-dd
      var formattedDate = date100WeeksBefore.toISOString().split("T")[0];
      // Assign formatted date to startDate
      startDate = formattedDate;
      // Output the result
      //console.log(
      //   "100 weeks before",
      //   newEndDate.toDateString(),
      //   "is",
      //   formattedDate
      // );
    }
    if (freq === "M") {
      endDate = "2024-02-15";
      startDate = "2014-01-01";
      var newEndDate = new Date(endDate); // Parse endDate as a Date object
      // Create a new date based on the endDate
      var newDate = new Date(newEndDate);
      newDate.setMonth(newEndDate.getMonth() - (bigger + 50)); // Subtracting 100 months
      // Format the date as yyyy-mm-dd
      startDate = newDate.toISOString().split("T")[0];
    }
    // set the date with start and end date
    setGraphDate({
      startDate: startDate,
      endDate: endDate,
    });
  };

  const handleClickLike = (event) => {
    // handle the like action
    toggleLikeAction();
  };

  const handleClickBookmark = (event) => {
    // if dashboard is already bookamrked removing the bookmark else creating new bookmark.
    if (isDashboardBookmarked) {
      //
      togglebookmarkAction();
    } else {
      setIsBookmarkModalOpen(true);
    }
  };

  const handleClickBookmarkEdit = (event) => {
    // showing the bookmark edit modal
    setIsBookmarkModalOpen(true);
  };

  // bookmark functionality.
  const handleBookmarkNameChange = (event) => {
    //console.log("setting the bookamrk name", event.target.value)
    setBookmarkName(event.target.value);
    setBookmarkNameError("");
  };

  const handleBookmarkDescriptionChange = (event) => {
    //console.log("setting the bookamrk description", event.target.value)
    setBookmarkDescription(event.target.value);
  };

  const handleChangeBookmarkFolder = (event) => {
    //console.log("setting the bookamrk folder", event.target.value)
    setSelectedBookmarkFolder(event.target.value);
    setBookmarkFolderError("");
    if (event.target.value === "0") {
      handleCloseBookmarkModal();
      showBookmarkGroouperModal();
    }
  };

  const handleChangeIsBookmarkPublic = (event) => {
    //console.log("setting the bookamrk ispublic", event.target.checked)
    setIsBookmarkPublic(event.target.checked);
  };

  const handleBookmarkSubmit = () => {
    //console.log("handeling bookmark submit")
    if (validateBookmark()) {
      isDashboardBookmarked ? updateBookmarkAction() : togglebookmarkAction();
    }
  };

  const validateBookmark = () => {
    // validates the mandatory fields while creating bookmark shows the proper message if not valid.

    let isValid = true;
    if (!bookmarkName?.trim()) {
      isValid = false;
      //console.log("")
      setBookmarkNameError("Please enter the name for bookmark.");
    }

    //console.log("typeof selectedBookmarkFolder", typeof selectedBookmarkFolder)
    //console.log("selectedBookmarkFolder", selectedBookmarkFolder)
    if (selectedBookmarkFolder === "0") {
      isValid = false;
      setBookmarkFolderError("Please select the folder for the bookmark.");
    }

    return isValid;
  };

  const togglebookmarkAction = () => {
    const bookmarkParameters = getBookmarkParameters();

    const data = {
      parameters: bookmarkParameters,
      dashboard_id: dashboardInfo.id, //need to add the dashboard id here.
      description: bookmarkDescription,
      name: bookmarkName,
      is_bookmark_public: isBookmarkPublic,
      bookmark_grouper_id: selectedBookmarkFolder,
    };

    toggleBookmark(data)
      .then((resp) => {
        // change the dashboard name to the bookmark name
        setDashboardTitle(resp.data.bookmark_name);

        // change the dashboard description to the bookmark description

        // make bookmark icon active
        setIsDashboardBookmarked(
          resp?.data?.is_bookmark_created ? true : false
        );

        // update the bookmark public flag.
        setIsBookmarkPublic(resp?.data?.is_bookmark_public ? true : false);

        // show the edit bookmark icon
        setIsBookmarkModalOpen(false);

        // if bookmark is removed reseting the input fields
        if (!resp.data.is_bookmark_created) {
          setBookmarkName("");
          setBookmarkDescription("");
          setIsBookmarkPublic(false);
        }

        // showing the notification message
        notification.success({
          message: "Done!",
          description: resp.data.message,
          placement: "bottomRight",
        });
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: err.response.data?.message || defualtErrorMessage,
          placement: "bottomRight",
        });
        //console.log("this is the errror for toggle bookmark", err)
      });
  };

  const updateBookmarkAction = () => {
    //console.log("updating the bookamrk")
    const bookmarkParameters = getBookmarkParameters();

    const data = {
      bookmark_parameters: bookmarkParameters,
      dashboard_id: dashboardInfo.id, //need to add the dashboard id here.
      bookmark_description: bookmarkDescription,
      bookmark_name: bookmarkName,
      is_bookmark_public: isBookmarkPublic,
      bookmark_grouper_id: selectedBookmarkFolder,
    };

    updateBookmark(data)
      .then((resp) => {
        // change the dashboard name to the bookmark name
        setDashboardTitle(resp.data.bookmark_name);

        // change the dashboard description to the bookmark description

        // make bookmark icon active
        // setIsDashboardBookmarked(resp?.data?.is_bookmark_created ? true : false)

        // update the bookmark public flag.
        // setIsBookmarkPublic(resp?.data?.is_bookmark_public ? true : false)

        // show the edit bookmark icon
        setIsBookmarkModalOpen(false);

        // showing the notification message
        notification.success({
          message: "Done!",
          description: resp.data.message,
          placement: "bottomRight",
        });
      })
      .catch((err) => {
        notification.error({
          message: "Error",
          description: err.response.data?.message || defualtErrorMessage,
          placement: "bottomRight",
        });
        //console.log("this is the errror for toggle bookmark", err)
      });
  };

  const toggleLikeAction = () => {
    const favoriteDashboardData = {};
    favoriteDashboardData.task = !isDashboardLiked;
    favoriteDashboardData.dashboard = dashboardInfo.id;
    toggleFavoriteDashboard(favoriteDashboardData)
      .then((resp) => {
        // changing the like icon.
        setIsDashboardLiked((prevState) => !prevState);
        notification.success({
          message: "Done!",
          description: resp.data.message,
          placement: "bottomRight",
        });
      })
      .catch((err) => {
        //console.log("this is the errror for toggle bookmark", err)
        notification.error({
          message: "Error",
          description: err.response.data?.message || defualtErrorMessage,
          placement: "bottomRight",
        });
      });
  };

  const getBookmarkParameters = () => {
    // const startDate = graphDate.startDate;
    // const endDate = graphDate.endDate;

    const bookmarkParameters = `${
      dashboardInfo?.link
    }?asset_type=${encodeURIComponent(
      JSON.stringify(selectAsset)
    )}&countries=${encodeURIComponent(
      JSON.stringify(selectCountry)
    )}&indexes=${encodeURIComponent(
      JSON.stringify(defaultIndice)
    )}&exchanges=${encodeURIComponent(
      defaultExchange
    )}&frequencies=${encodeURIComponent(
      JSON.stringify(defaultFrequency)
    )}&initialinvestment=${encodeURIComponent(
      JSON.stringify(selectInitInvestment)
    )}&from_index_constituents=${encodeURIComponent(
      JSON.stringify(selectFromIndexConst)
    )}&strat_name=${encodeURIComponent(JSON.stringify(selectStrategyType))}`;

    //console.log(bookmarkParameters);
    return bookmarkParameters;
  };

  const getParameters = () => {
    // const startDate = graphDate.startDate;
    // const endDate = graphDate.endDate;

    const parameters = `asset_type=${encodeURIComponent(
      JSON.stringify(selectAsset)
    )}&countries=${encodeURIComponent(
      JSON.stringify(selectCountry)
    )}&indexes=${encodeURIComponent(
      JSON.stringify(defaultIndice)
    )}&exchanges=${encodeURIComponent(
      defaultExchange
    )}&frequencies=${encodeURIComponent(
      JSON.stringify(defaultFrequency)
    )}&initialinvestment=${encodeURIComponent(
      JSON.stringify(selectInitInvestment)
    )}&from_index_constituents=${encodeURIComponent(
      JSON.stringify(selectFromIndexConst)
    )}&strat_name=${encodeURIComponent(JSON.stringify(selectStrategyType))}`;

    //console.log(parameters);
    return parameters;
  };

  const handelClickBookmarkGrouper = (event) => {
    // check if the form is field
    if (validateBookmarkGrouper()) {
      // making the api call for creating new bookmark grouper

      const payload = { bookmark_grouper_name: bookmarkGrouperInput.trim() };
      createBookmarkGrouper(payload)
        .then((resp) => {
          // hide the grouper modal
          setIsBookmarkGrouperModalOpen(false);

          // Add the newly created grouper to the folder
          const newGrouper = resp.data;
          setBookmarkFolders((prev) => [...prev, newGrouper]);

          //  selecting the newly created created folder
          setSelectedBookmarkFolder(newGrouper.id);

          // showing the notification that new bookmark modal is created successfully.
          notification.success({
            message: "Success!",
            description: "New folder is created Successfully!",
            placement: "bottomRight",
          });

          // show the bookmark modal select the newly created
          setIsBookmarkModalOpen(true);
        })
        .catch((err) => {
          notification.error({
            message: "Error",
            description: err.response.data?.message || defualtErrorMessage,
            placement: "bottomRight",
          });
        });
    }
  };

  const handleChangeBookmarkGrouperInput = (event) => {
    setBookmarkGrouperInput(event.target.value);
  };

  const handleCloseBookmarkGrouperModal = () => {
    setIsBookmarkGrouperModalOpen(false);
  };

  const showBookmarkGroouperModal = () => {
    setIsBookmarkGrouperModalOpen(true);
  };

  const validateBookmarkGrouper = () => {
    let isValid = true;

    if (!bookmarkGrouperInput?.trim()) {
      isValid = false;
      setBookmarkGrouperInputError("Please enter the name Folder Name!");
    }

    return isValid;
  };

  const handleCloseNotificationModal = () => {
    setShowNotificationModal(false);
  };

  const handleClickSubmitStrategy = (e) => {
    e.preventDefault();
    fetchStrategyData();
  };

  const fetchStrategyData = () => {
    setIsStrategyLoading(true);
    let fromIndexConstituent = true;
    if (!selectFromIndexConst) {
      fromIndexConstituent = false;
    }
    let countries = "";
    if (selectAsset["value"] === "Unknown") {
      countries = "Unknown";
    } else {
      countries = selectCountry["value"];
    }
    //const startDate = defaultFrequency['value'] === 'W' ? "2020-01-01" : defaultFrequency['value'] === 'M' ? "2013-01-01" : "2023-01-01";

    const parameters = getParameters();
    var indices = encodeURIComponent(defaultIndice["value"]);

    const params = {
      id_tag: "strategy__backtest",
      invoke_type: "aws",
      logic_function: "run_adhoc_strategy",
      asset_type: selectAsset["value"],
      end_dt: graphDate["endDate"],
      start_dt: graphDate["startDate"],
      countries: countries,
      exchanges: defaultExchange["value"],
      frequency: defaultFrequency["value"],
      indexes: indices,
      initial_investment: selectInitInvestment,
      benchmark_dma: benchmarkDma,
      risk_free_rate: 0.04,
      lookback_period: lookBackPeriod,
      no_of_positions: 3,
      rebalance_frequency: 23,
      use_benchmark_exit_signal: true,
      from_index_constituents: fromIndexConstituent,
      strat_name: selectStrategyType["value"] || defaultStrategy["value"],
      notification_name:
        selectStrategyType["label"] || defaultStrategy["label"],
      from_index_const: selectFromIndexConst,
      // "parameters" : parameters
    };
    getStrategy(params)
      .then((resp) => {
        //console.log("inside the data fetch");
        //console.log("resp.data", resp.data);

        if (resp.data.body.request_id === "dummy") {
          //console.log("insideif");
          const stratBenchmark = JSON.parse(
            resp.data.body.result.strat_benchmark
          );
          const stratSummary = JSON.parse(resp.data.body.result.strat_summary);
          const stratInclusionExclusion = JSON.parse(
            resp.data.body.result.strat_inclusion_exclusion
          );

          const stratPerformance = JSON.parse(
            resp.data.body.result.strat_performance
          );
          //console.log("printing");
          //console.log(
          //   stratPerformance[0]["performance_data"]["drawdown_details"]
          // );
          const portfiloReturnData =
            stratPerformance[0]["performance_data"]["portfolio_returns"];
          const benchmarkReturnData =
            stratPerformance[0]["performance_data"]["benchmark_returns"];

          const monthlYReturnData =
            stratPerformance[0]["performance_data"]["monthly_returns"];
          const monthlyReturnJson = JSON.parse(monthlYReturnData);
          setMonthlyReturnData(monthlyReturnJson);
          const metrics = stratPerformance[0]["performance_data"]["metrics"];
          const metricJson = JSON.parse(metrics);
          // data to prepare for comparison between benchmark and portfolio

          const gridData = [];

          for (const metric of Object.keys(metricJson["Benchmark"])) {
            const benchmarkValue = metricJson["Benchmark"][metric];
            const strategyValue = metricJson["Strategy"][metric];
            gridData.push({
              Metric: metric,
              Benchmark: benchmarkValue,
              Strategy: strategyValue,
            });
          }

          setMetricRowData(gridData);

          // setting data for plotting return data
          setPortfolioData(portfiloReturnData);
          setBenchmarkData(benchmarkReturnData);

          // setting data for EOY bar chart
          const eoyReturnBenchmark =
            stratPerformance[0]["performance_data"]["eoy_returns_benchmark"];
          const eoyReturnPortfolio =
            stratPerformance[0]["performance_data"]["eoy_returns_portfolio"];

          const eoyReturnData = generateChartData(
            eoyReturnBenchmark,
            eoyReturnPortfolio
          );
          // console.log("printing data for bar")
          // console.log(eoyReturnData)
          setEoyReturnBarData(eoyReturnData);
          // drawdown chart
          // const drawDownDetails =  stratPerformance[0]['performance_data']['drawdown_details']
          // console.log("printing drawdown data")
          // console.log(drawDownDetails)
          const underwaterData =
            stratPerformance[0]["performance_data"]["underwater_data"];
          // console.log("printing underwater data")
          // console.log(underwaterData)
          setUnderwaterData(underwaterData);
          // getting data for monthly return

          const cumulativeReturnPort =
            stratPerformance[0]["performance_data"][
              "cumulative_returns_portfolio"
            ];
          const cumulativeReturnBench =
            stratPerformance[0]["performance_data"][
              "cumulative_returns_benchmark"
            ];

          setCumulativeReturnBenchmarkData(cumulativeReturnPort);
          setCumulativeReturnPortfolioData(cumulativeReturnBench);

          setBenchmarkRowData(stratBenchmark); // Store stratbenchmark data in rowData state variable
          setSummaryRowData(stratSummary); // Store stratbenchmark data in rowData state variable
          setInexRowData(stratInclusionExclusion);
          setPerformanceRowData(stratPerformance); // Store stratbenchmark data in rowData state variable
          if (stratBenchmark.length > 0) {
            const firstObjectKeys = Object.keys(stratBenchmark[0]);
            const newColumnDefs = firstObjectKeys
              .filter((key) => !excludedColumns.includes(key))
              .map((key) => ({
                headerName: key
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
                field: key,
              }));
            const filteredColumnDefs = newColumnDefs.filter(
              (column) => !excludedColumns.includes(column.field)
            );
            setBenchColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
          }

          if (stratSummary.length > 0) {
            const firstObjectKeys = Object.keys(stratSummary[0]);
            const newColumnDefs = firstObjectKeys.map((key) => ({
              headerName: key
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase()),
              field: key,
            }));
            const filteredColumnDefs = newColumnDefs.filter(
              (column) => !excludedColumns.includes(column.field)
            );
            setSummaryColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
          }
          if (stratPerformance.length > 0) {
            const firstObjectKeys = Object.keys(stratPerformance[0]);
            const newColumnDefs = firstObjectKeys.map((key) => ({
              headerName: key
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase()),
              field: key,
            }));
            const filteredColumnDefs = newColumnDefs.filter(
              (column) => !excludedColumns.includes(column.field)
            );
            setPerformanceColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
          }

          if (stratInclusionExclusion.length > 0) {
            const firstObjectKeys = Object.keys(stratInclusionExclusion[0]);
            const newColumnDefs = firstObjectKeys.map((key) => ({
              headerName: key
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase()),
              field: key,
            }));
            const filteredColumnDefs = newColumnDefs.filter(
              (column) => !excludedColumns.includes(column.field)
            );
            setInexColumnDefs(filteredColumnDefs); // Store column definitions in columnDefs state variable
          }
        } else {
          // show user pop up
          // const respData = JSON.parse(resp.data.body);
          const respData = resp.data.body;
          //console.log("respDataa", respData);
          setShowNotificationModal(true);
          window.fetchNotificationStatus(respData.request_id);
          try {
            let serializedState = sessionStorage.getItem(
              "notification-request-ids"
            );
            if (serializedState) {
              const parsedserializedState = JSON.parse(serializedState);
              parsedserializedState.push(respData.request_id);
              serializedState = JSON.stringify(parsedserializedState);
              sessionStorage.setItem(
                "notification-request-ids",
                serializedState
              );
            } else {
              serializedState = JSON.stringify([respData.request_id]);
              sessionStorage.setItem(
                "notification-request-ids",
                serializedState
              );
            }
          } catch (error) {
            console.error("Could not load state", error);
          }
          //console.log("inside else");
        }
        setIsStrategyLoading(false);
      })
      .catch((err) => {
        //console.log("this is the error", err);
      });
  };

  return (
    <>
      {isStrategyLoading && (
        <div className="loader-container">
          <PreLoader />
        </div>
      )}
      <BookmarkModal
        isBookmarkModalOpen={isBookmarkModalOpen}
        handleCloseBookmarkModal={handleCloseBookmarkModal}
        bookmarkFolders={bookmarkFolders}
        bookmarkName={bookmarkName}
        bookmarkNameError={bookmarkNameError}
        handleBookmarkNameChange={handleBookmarkNameChange}
        bookmarkDescription={bookmarkDescription}
        handleBookmarkDescriptionChange={handleBookmarkDescriptionChange}
        selectedBookmarkFolder={selectedBookmarkFolder}
        bookmarkFolderError={bookmarkFolderError}
        handleChangeBookmarkFolder={handleChangeBookmarkFolder}
        isBookmarkPublic={isBookmarkPublic}
        handleChangeIsBookmarkPublic={handleChangeIsBookmarkPublic}
        handleBookmarkSubmit={handleBookmarkSubmit}
      />

      <BookmarkGrouperModal
        isModalOpen={isBookmarkGrouperModalOpen}
        handleCloseModal={handleCloseBookmarkGrouperModal}
        modalInputValue={bookmarkGrouperInput}
        modalInputError={bookmarkGrouperInputError}
        handleClick={handelClickBookmarkGrouper}
        handleChangeInput={handleChangeBookmarkGrouperInput}
      />

      <StrategyFetchingNotificationModal
        open={showNotificationModal}
        handleClose={handleCloseNotificationModal}
      />

      <Grid
        container
        item
        spacing={2}
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: "#000",
          display: "grid",
        }}
      >
        <DashboardHeader
          title={dashboardTitle}
          handleClickBookmark={handleClickBookmark}
          handleClickLike={handleClickLike}
          isDashboardLiked={isDashboardLiked}
          isDashboardBookmarked={isDashboardBookmarked}
          handleClickBookmarkEdit={handleClickBookmarkEdit}
        />
      </Grid>
      <Grid
        container
        item
        spacing={2}
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: "#000",
          display: "grid",
          gridTemplateColumns: { md: "1fr 1fr 1fr 1fr 1fr" },
          gap: 2,
        }}
      >
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
            className="select-container"
          >
            Strategy Type
            <SelectBox
              options={strategyList}
              defaultValue={defaultStrategy}
              value={selectStrategyType}
              isDisabled={false}
              isLoading={false}
              isClearable={false}
              isSearchable={false}
              handleSelectChange={handleChangeStrategy}
              isMulti={false}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              //display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
            className="select-container"
          >
            Asset Type
            <SelectBox
              options={assetList}
              defaultValue={defaultAsset}
              value={selectAsset}
              isDisabled={false}
              isLoading={false}
              isClearable={false}
              isSearchable={false}
              handleSelectChange={handleChangeAsset}
              isMulti={false}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              // gridTemplateColumns: { md: '1fr 1fr' },
              // gap: 2,
            }}
            className="select-container"
          >
            Country
            <SelectBox
              options={countryList}
              defaultValue={defaultCountry}
              value={selectCountry}
              isDisabled={countryDisabled}
              isLoading={false}
              isClearable={false}
              isSearchable={false}
              handleSelectChange={handleChangeCountry}
              isMulti={false}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
            className="select-container"
          >
            Exchange
            <SelectBox
              options={selectExchange}
              defaultValue={defaultExchange}
              value={defaultExchange}
              isDisabled={false}
              isLoading={false}
              isClearable={false}
              isSearchable={false}
              handleSelectChange={handleChangeExchange}
              isMulti={false}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
            className="select-container"
          >
            Indices
            <SelectBox
              options={selectIndice}
              defaultValue={defaultIndice}
              value={defaultIndice}
              isDisabled={false}
              isLoading={false}
              isClearable={false}
              isSearchable={false}
              handleSelectChange={handleChangeIndice}
              isMulti={false}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        item
        spacing={2}
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: "#000",
          display: "grid",
          gridTemplateColumns: { md: "1fr 1fr 1fr 1fr 1fr " },
          gap: 2,
        }}
      >
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
            className="select-container"
          >
            Frequency
            <SelectBox
              options={frequencyList}
              defaultValue={defaultFrequency}
              value={defaultFrequency}
              isDisabled={false}
              isLoading={false}
              isClearable={false}
              isSearchable={false}
              handleSelectChange={handleChangeFrequency}
              isMulti={false}
            />
          </Box>
        </Grid>
        {/* Select Date: */}
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              // gridTemplateColumns: { md: '1fr 1fr' },
              // gap: 2,
            }}
          >
            <>
              <label htmlFor="date-picker-range">Date Range:</label>
              <RangePicker
                id="date-picker-range"
                size="midle"
                className="ant-date-picker-input"
                pickerStyle={{ backgroundColor: "#000", color: "#fff" }} // Add
                onCalendarChange={handleChangeDate}
                // defaultValue={[
                //   dayjs(graphDate.startDate, graphDateFormat),
                //   dayjs(graphDate.endDate, graphDateFormat),
                // ]}
                value={[
                  dayjs(graphDate.startDate, graphDateFormat), // Assuming graphDate.startDate is in the correct format
                  dayjs(graphDate.endDate, graphDateFormat), // Assuming graphDate.endDate is in the correct format
                ]}
                disabled={[true, false]}
              />
            </>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 4,
            }}
            className="select-container"
          >
            From Index Constituents
            <br />
            <RadioItem
              onRadioChange={radioOnChange}
              value={selectFromIndexConst}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
            className="select-container"
          >
            Initial Investment($)
            <InitialInvestment
              onInvestmentChange={investmentOnChange}
              value={selectInitInvestment}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              // p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              // display: 'grid',
              //  gridTemplateColumns: { md: '1fr 1fr' },
              gap: 2,
            }}
            className="select-container"
          >
            <button
              className="btn secondary_btn"
              onClick={handleClickSubmitStrategy}
            >
              Run Strategy
            </button>
          </Box>
        </Grid>
      </Grid>

      {portfolioData?.length ? (
        <Grid item xs={12}>
          <Grid
            container
            item
            spacing={2}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              display: "grid",
            }}
          >
            <Box>
              Portfolio vs Benchmark
              <PortfolioDataGrid
                rowData={metricRowData}
                colDefs={metricColumnDef}
              />
            </Box>
            <br />
            <br />
            <Box>
              Strategy Summary
              <PortfolioDataGrid
                rowData={summaryRowData}
                colDefs={summaryColumnDefs}
              />
            </Box>
            <br />
            <br />
            <Box>
              Portfolio Benchmark
              <PortfolioDataGrid
                rowData={benchmarkRowData}
                colDefs={benchColumnDefs}
              />
            </Box>
            <br />
            <br />
            <Box>
              Inclusion Exclusion Details
              <PortfolioDataGrid
                rowData={inexRowData}
                colDefs={inexColumnDefs}
              />
            </Box>
            <br />
            <br />
          </Grid>
          <Grid
            container
            item
            spacing={2}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              display: "grid",
              gridTemplateColumns: { md: "1fr 1fr  " },
              gap: 2,
            }}
          >
            <Box
              id="secondary-legend-div"
              sx={{
                position: "relative",
                textAlign: "center",
                fontSize: "14px",
              }}
            >
              {"Benchmark vs Portfolio Monthly Returns"}
              <Box
                sx={{
                  mt: 1,
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "15px",
                    height: "15px",
                    backgroundColor: "#8A9A5B",
                    marginRight: "5px",
                  }}
                ></span>
                <span> Benchmark </span>
                <span
                  style={{
                    display: "inline-block",
                    width: "15px",
                    height: "15px",
                    backgroundColor: "#FF0000",
                    marginRight: "5px",
                    marginLeft: "25px",
                  }}
                ></span>
                <span> Portfolio </span>
              </Box>
            </Box>

            <Box
              id="secondary-legend-div"
              sx={{
                position: "relative",
                textAlign: "center",
                fontSize: "14px",
              }}
            >
              {"Benchmark vs Portfolio EOY Returns"}
            </Box>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              display: "grid",
              gridTemplateColumns: { md: "1fr 1fr  " },
              gap: 2,
            }}
          >
            <Box sx={{ border: "1px solid" }}>
              <PortfolioChart
                benchmarkData={benchmarkData}
                portfolioData={portfolioData}
              />
            </Box>
            <Box sx={{ border: "1px solid" }}>
              <VerticalBarChart data={eoyReturnBarData} title={barChartTitle} />
            </Box>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              display: "grid",
              gridTemplateColumns: { md: "1fr 1fr " },
              gap: 2,
            }}
          >
            <Box
              id="secondary-legend-div"
              sx={{
                position: "relative",
                textAlign: "center",
                fontSize: "14px",
              }}
            >
              {"Portfolio Monthly Return Heatmap"}
            </Box>
            <Box
              id="secondary-legend-div"
              sx={{
                position: "relative",
                textAlign: "center",
                fontSize: "14px",
              }}
            >
              {"Cumulative Return Portfolio vs Benchmark "}
              <Box
                sx={{
                  mt: 1,
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "15px",
                    height: "15px",
                    backgroundColor: "#8A9A5B",
                    marginRight: "5px",
                  }}
                ></span>
                <span> Benchmark </span>
                <span
                  style={{
                    display: "inline-block",
                    width: "15px",
                    height: "15px",
                    backgroundColor: "#FF0000",
                    marginRight: "5px",
                    marginLeft: "25px",
                  }}
                ></span>
                <span> Portfolio </span>
              </Box>
            </Box>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#000",
              display: "grid",
              gridTemplateColumns: { md: "1fr 1fr " },
              gap: 2,
            }}
          >
            <Box sx={{ border: "1px solid" }}>
              <HeatmapChart monthlydata={monthlyReturnData} />
              {/* <UnderWaterChart data={underwaterData}  /> */}
            </Box>
            <Box sx={{ border: "1px solid" }}>
              <PortfolioChart
                benchmarkData={cumulativeReturnBenchmarkData}
                portfolioData={cumulativeReturnPortfolioData}
              />
            </Box>
          </Grid>
        </Grid>
      ) : (
        <>
          {isStrategyLoading ? null : (
            <Box
              sx={{
                color: "#fff", // White text color for better readability on dark backgrounds
                backgroundColor: "#121212", // A dark, almost black background color
                borderLeft: "4px solid #1e90ff", // Keeping the vibrant blue border for a pop of color
                p: 3, // Padding for a spacious feel remains the same
                mb: 3, // Margin bottom for separation also remains the same
                fontSize: "1rem", // Font size remains comfortable for reading
                borderRadius: "8px", // Rounded corners for a friendly appearance
                boxShadow: "0 4px 6px rgba(0,0,0,0.5)", // A stronger shadow for depth on a dark background
                display: "flex",
                flexDirection: "column",
                gap: 2, // Space between child components
                mt: 3, // Top margin for positioning
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <span role="img" aria-label="rocket">
                  🚀
                </span>
                Ready to launch your strategy? Just make sure you've selected
                all the right fields, then give the{" "}
                <strong>"Run Strategy"</strong> button a tap!
              </Box>
              <Box sx={{ fontStyle: "italic" }}>
                Got questions? Our friendly chatbot is eager to assist you with
                using this tool.
              </Box>
              <Box>
                Need a hand? We're
                <a
                  href="/contact"
                  style={{
                    color: "#4DD0E1", // A lighter blue color for links to stand out on the dark background
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  here to help
                </a>{" "}
                anytime!
              </Box>
            </Box>
          )}
        </>
      )}
    </>
  );
}
